import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import styles from './EditStatusModal.module.scss';
import ConfirmChangeStatusModal from './ConfirmChangeStatusModal';
import { useMutation } from '@apollo/client';
import { UPDATE_ADMIN_COMPANY_STATUS } from '../../../../../api';
import { openNotification, Button } from 'tt-ui-lib/core';

const statuses = [
  { value: true, label: 'Draft' },
  { value: false, label: 'Active' },
];

const EditStatusModal = ({ open, companyInfo, handleClose, setCompaniesList }) => {
  const [changeCompanyStatusModal, setChangeCompanyStatusModal] = useState(false);
  const [checkedStatus, setCheckedStatus] = useState(companyInfo.is_draft);
  const [editCompanyStatus] = useMutation(UPDATE_ADMIN_COMPANY_STATUS);

  useEffect(() => {
    setCheckedStatus(companyInfo.is_draft);
  }, [open]);

  const handleChangeStatus = async () => {
    const res = await editCompanyStatus({
      variables: {
        input: {
          id: companyInfo.id,
          is_draft: checkedStatus,
        },
      },
    });
    if (res && res.data && res.data.editCompanyStatus) {
      const updatedData = res.data.editCompanyStatus;
      setCompaniesList((prevCompanies) =>
        prevCompanies.map((company) =>
          company.id === updatedData.id ? { ...company, is_draft: updatedData.is_draft } : company
        )
      );
      openNotification({
        message: 'Status updated successfully!',
        duration: 2000,
        type: 'success',
      });
    }
    setChangeCompanyStatusModal(false);
    handleClose();
  };
  return (
    <>
      <Modal
        BackdropProps={{
          style: {
            backgroundColor: 'white',
            backdropFilter: 'blur(14px)',
            background: 'rgba(250, 250, 250, 0.8)',
          },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box className={styles.editStatusModal}>
          <Box className={styles.modalTitle}>
            Do you want to change a company status?
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 30,
                top: 20,
                color: (theme) => theme.palette.grey[900],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className={styles.modalContent}>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={checkedStatus}
                name="radio-buttons-group"
                onChange={(e) => setCheckedStatus(e.target.value === 'true')}
              >
                {statuses.map((item) => (
                  <FormControlLabel
                    value={item.value}
                    control={<Radio />}
                    label={<Typography className={styles.statusName}>{item.label}</Typography>}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box className={styles.modalActions}>
            <Button
              type="default"
              onClick={() => {
                setCheckedStatus('');
                handleClose();
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setChangeCompanyStatusModal(true);
              }}
              disabled={checkedStatus === companyInfo.is_draft}
            >
              CONFIRM
            </Button>
          </Box>
        </Box>
      </Modal>
      <ConfirmChangeStatusModal
        changeStatus={() => handleChangeStatus()}
        companyName={companyInfo.company_name}
        open={changeCompanyStatusModal}
        handleClose={() => {
          setChangeCompanyStatusModal(false);
        }}
      />
    </>
  );
};

export default EditStatusModal;
